
import React from 'react';

interface QuickActionsProps {
  phone: string;
  address: string;
  name: string;
  website: string;
  onShare: () => void;
}

export default function QuickActions({
  phone,
  address,
  name,
  website,
  onShare,
}: QuickActionsProps) {
  // Basic validation to avoid malformed URLs
  const safePhone = phone?.trim() ?? '';
  const safeName = name?.trim() ?? '';
  const safeAddress = address?.trim() ?? '';
  const safeWebsite = website?.trim() ?? '#';

  const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${safeName} ${safeAddress}`
  )}`;

  return (
    <div className="bg-white border-b border-gray-100 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-2 py-3 overflow-x-auto">
          {/* Call button */}
          {safePhone && (
            <a
              href={`tel:${safePhone}`}
              className="flex items-center gap-2 px-4 py-2.5 bg-teal-600 text-white text-sm font-semibold rounded-lg hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-sm"></i>
              Call Now
            </a>
          )}

          {/* Directions button */}
          {safeName && safeAddress && (
            <a
              href={googleMapsLink}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-2 px-4 py-2.5 bg-gray-100 text-gray-700 text-sm font-semibold rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-navigation-line text-sm"></i>
              Directions
            </a>
          )}

          {/* Website button */}
          {safeWebsite !== '#' && (
            <a
              href={safeWebsite}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-2 px-4 py-2.5 bg-gray-100 text-gray-700 text-sm font-semibold rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-global-line text-sm"></i>
              Website
            </a>
          )}

          {/* Share button */}
          <button
            onClick={onShare}
            type="button"
            className="flex items-center gap-2 px-4 py-2.5 bg-gray-100 text-gray-700 text-sm font-semibold rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-share-line text-sm"></i>
            Share
          </button>
        </div>
      </div>
    </div>
  );
}
